import React from 'react';
import { HeaderTemplate, KeyValue, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import AccessMatrixWindowPeriod from '../../../components/cards/AccessMatrixWindowPeriod';
import RouteKey from '../../../routes/key';

const { exam } = RouteKey.child;
const { examRegistrations } = RouteKey.exam.child;

interface ExamNotAvailableProps {
  eligibleErrorCode: string;
  examTitle: string;
  examTypeDisplay: string;
}

const ExamNotAvailable = (props: ExamNotAvailableProps) => {
  const { eligibleErrorCode, examTypeDisplay, examTitle } = props;

  const { t } = useTranslation();
  let contentBody;
  let link = '/';
  let label = t('exam->>ResultListing.Back to Homepage');

  switch (eligibleErrorCode) {
    case '5004':
      contentBody = t('exam->>RegisterExamInstructions.NotAvailable');
      break;
    case '5010':
    case '2011':
      contentBody = t('exam->>RegisterExamInstructions.AlreadyRegistered');
      label = t('exam->>RegisterExamInstructions.GoToRegisteredExams');
      link = `/${exam}/${examRegistrations.route}`;
      break;
    default:
      contentBody = t('exam->>RegisterExamInstructions.WeAreSorryNoAccess');
      break;
  }
  return (
    <>
      <TitleHeader title={examTitle} />
      {examTypeDisplay && (
        <HeaderTemplate>
          <KeyValue
            keyText={t('exam->>RegisterExamInstructions.Exam Level')}
            valueText={examTypeDisplay}
          />
        </HeaderTemplate>
      )}

      <AccessMatrixWindowPeriod contentBody={contentBody} buttonLink={link} buttonLabel={label} />
    </>
  );
};

export default ExamNotAvailable;
